import { mount } from 'svelte';
import App from './App.svelte';
import { initializeTheme } from './services/themeService.js';
import { initializeAnalytics } from './services/analyticsService.js';
import { initializeSentry } from './services/sentryService.js';
import { logger } from './utils/logger.js';
import { env } from './config/env.js';
import './styles/global.css';

// Initialize services
async function initializeApp() {
  try {
    // Initialize Sentry first for error tracking
    if (env.isProduction) {
      initializeSentry();
    }

    // Initialize theme (must be early to prevent flash)
    initializeTheme();

    // Initialize analytics (respects cookie consent)
    initializeAnalytics();

    logger.info('App initialized successfully');
  } catch (error) {
    logger.error('Failed to initialize app:', error);
  }
}

// Initialize services before mounting
initializeApp();

// Mount the app
const app = mount(App, {
  target: document.getElementById('app')
});

// Register service worker for PWA
if ('serviceWorker' in navigator && env.isProduction) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      logger.info('ServiceWorker registered:', registration.scope);
    } catch (error) {
      logger.error('ServiceWorker registration failed:', error);
    }
  });
}

export default app;
